import { Fragment, h } from 'preact';
import { useEffect, useState, useRef } from 'preact/hooks';
import { ProjConstants } from '../../../../constants/projConsts';
import './snippet.scss';

export function SnippetSuggestion(props: any) {

    let prevClass : any = '';

    const handleEmptyLine = props?.msgData?.hostInstance?.rootService?.handleEmptyLine;
    const hostInstance = props?.msgData?.hostInstance;
    const languageData = hostInstance?.languagedata

    const mouseLeave = () => {
        if (prevClass) {
            hostInstance?.chatEle?.querySelectorAll(prevClass)?.forEach((el: any) => el?.classList?.remove('selection-on-snippet-color'));
        }
    }

    const hoverOnSource = (sourceInx: any, type: any, i: any) => {
        if (prevClass) {
            hostInstance?.chatEle?.querySelectorAll(prevClass)?.forEach((el: any) => el?.classList?.remove('selection-on-snippet-color'));
        }
        prevClass = '.fragment-ext-' + sourceInx + '-' + props?.msgData?.suggestionIndex;
        hostInstance?.chatEle?.querySelectorAll(prevClass)?.forEach((el: any) => el?.classList?.add('selection-on-snippet-color'));
    }

    const getSnippetContentClass = (content: any) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(content, "text/html");
        const span = doc.querySelector("span");
        const className = span?.className; 
        if(className){
            return className;
        }
        return '';
    }

    return (
        <div>
            {props?.msgData?.snippets?.map((snippet: any, i: any) => (
                <div className="suggestion-item-card aa-each-suggestion " key={i}>
                    <div className="suggestion-header-faq aa-suggestion-header">
                        <div className="titles-info-sec aa-suggestion-title">
                            {snippet.title && (
                                <h2 className="aa-text-xs">{snippet.title}</h2>
                            )}
                            {/* {snippet.send && (
                                <div className="aa-text-xs sent-msg-text aa-sent-text">
                                    {snippet.send === 'send' ? 'SENT' : 'COPIED'}
                                </div>
                            )} */}
                        </div>
                    </div>

                    <div className="suggestion-body-faq">
                        <p className="aa-desc-xs suggestion-paragraph aa-snippet-content-ref1">
                            {snippet.contentArray.map((content: any, ii: any) => (content?.length > 0 && (
                                <div key={ii} dangerouslySetInnerHTML={{ __html: handleEmptyLine(content) }}></div>
                            )
                            ))}
                        </p>
                        <div className="more-links-buttons aa-external-seemore-buttons aa-hidden">
                            <button className="more-link-text aa-text-xs aa-more-button" role="link">{languageData?.MORE_TEXT}</button>
                        </div>
                        {snippet.internalInfo?.length > 0 && (
                            <Fragment>
                                <div className="line-with-text-heading">
                                    <h2>{languageData?.INTERNAL_INFO}</h2>
                                    <span></span>
                                </div>
                                <p className="aa-desc-xs suggestion-paragraph aa-snippet-content-ref2">
                                    {snippet.internalInfo.map((content: any, ii: any) => (
                                        content?.length > 0 && (
                                            <div
                                                key={ii}
                                                className={`inner-text-snippet-selection ${getSnippetContentClass(content)} ${snippet.internalInfo.length > 1 && !snippet.isActCit ? 'snippet-list-style' : ''}`}
                                                dangerouslySetInnerHTML={{ __html: handleEmptyLine(content) }}
                                            ></div>
                                        )
                                    ))}
                                </p>
                                <div className="more-links-buttons aa-internal-seemore-buttons aa-hidden">
                                    <button className="more-link-text aa-text-xs aa-more-button" role="link">{languageData?.MORE_TEXT}</button>
                                </div>
                                <div className="line-with-text-heading">
                                    <span></span>
                                    <h2>{languageData?.INTERNAL_INFO}</h2>
                                </div>
                            </Fragment>
                        )}

                        {snippet?.sources?.length > 0 && (
                            <div className="souces-names-wrapper">
                                <h1 className="aa-desc-xs">{languageData?.SOURCES} :</h1>
                                <div className="source-names">
                                    {snippet.sources.map((source: any, ii: any) => (
                                        source.url && (
                                            <div
                                                key={ii}
                                                className="source-tag aa-source-tag"
                                                onMouseOver={() => hoverOnSource(ii + 1, 'ext', i)}
                                                onMouseLeave={mouseLeave}
                                            >
                                                {snippet.isActCit && <span>{ii + 1}</span>}
                                                <a title={source.title} className="aa-snippet-link">
                                                    {source?.title || `${languageData?.KNOW_MORE}`}
                                                </a>
                                            </div>
                                        )
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
}
